class CollectionFilters extends HTMLElement {
  constructor () {
    super()
    this.headers = []
    this.activeFilter = null
    this.handleFilterToggle = this.toggleFilter.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.setupListeners = this.setupListeners.bind(this)
  }

  connectedCallback () {
    this.setupListeners()
  }

  disconnectedCallback () {
    this.teardownListeners()
  }

  setupListeners () {
    this.teardownListeners()
    this.headers = Array.from(this.querySelectorAll('.js-filter-open'))
    this.headers.forEach(header => {
      header.addEventListener('click', this.handleFilterToggle)
    })
    document.addEventListener('click', this.handleOutsideClick)
  }

  teardownListeners () {
    this.headers.forEach(header => {
      header.removeEventListener('click', this.handleFilterToggle)
    })
    this.headers = []
    document.removeEventListener('click', this.handleOutsideClick)
  }

  getActiveFilterIds () {
    return this.headers
      .filter(header => header.classList.contains('is-active'))
      .map(header => header.id)
  }

  setActiveFilterIds (ids = []) {
    this.headers.forEach(header => {
      header.classList.remove('is-active')

      const filterList = header.nextElementSibling
      if (filterList && filterList.classList.contains('collection__filters__single__list')) {
        filterList.classList.remove('is-active')
      }
    })

    this.activeFilter = null

    ids.forEach((id) => {
      const header = this.querySelector(`#${id}`)
      const filterList = header && header.nextElementSibling

      if (!header || !filterList || !filterList.classList.contains('collection__filters__single__list')) {
        return
      }

      header.classList.add('is-active')
      filterList.classList.add('is-active')
      this.activeFilter = filterList
    })
  }

  toggleFilter (event) {
    event.stopPropagation()

    const header = event.currentTarget
    const filterList = header.nextElementSibling

    if (filterList && filterList.classList.contains('collection__filters__single__list')) {
      if (this.activeFilter && this.activeFilter !== filterList) {
        this.activeFilter.classList.remove('is-active')

        const previousHeader = this.activeFilter.previousElementSibling
        if (previousHeader && previousHeader.classList.contains('js-filter-open')) {
          previousHeader.classList.remove('is-active')
        }
      }

      const isActive = filterList.classList.toggle('is-active')
      header.classList.toggle('is-active', isActive)

      this.activeFilter = isActive ? filterList : null
    }
  }

  handleOutsideClick (event) {
    if (this.activeFilter) {
      if (!this.contains(event.target)) {
        this.activeFilter.classList.remove('is-active')

        const previousHeader = this.activeFilter.previousElementSibling
        if (previousHeader && previousHeader.classList.contains('js-filter-open')) {
          previousHeader.classList.remove('is-active')
        }

        this.activeFilter = null
      }
    }
  }
}

customElements.define('collection-filters', CollectionFilters)
